<template>
  <v-dialog
    v-model="show"
    scrollable
    max-width="800"
  >
    <v-card class="email-preview-dialog">
      <v-toolbar
        elevation="0"
      >
        <v-toolbar-title class="pl-5">
          Skickat mail
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="isSupport" text @click="openInNewTab">
          <v-icon left>mdi-open-in-new</v-icon>
          Öppna i ny flik
        </v-btn>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="container">
        <div v-html="htmlEmail"></div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'EmailPreviewDialog',
  data: () => ({}),
  computed: {
    ...mapGetters(
      {
        activeAuthSession: 'user/activeAuthSession'
      }
    ),
    ...mapState(
      {
        htmlEmail: state => state.email.htmlEmail
      }
    ),
    isSupport: function () {
      return this.activeAuthSession?.user?.is_support === true
    },
    show: {
      get () {
        return this.$store.state.email.showDialog
      },
      set (value) {
        this.$store.commit('email/SET_SHOW_DIALOG', value)
      }
    }
  },
  methods: {
    close: function () {
      this.show = false
    },
    openInNewTab: function () {
      const emailWindow = window.open('', '_blank')

      if (!emailWindow) {
        return
      }

      emailWindow.document.open()
      emailWindow.document.write(this.htmlEmail)
      emailWindow.document.close()
      emailWindow.opener = null

      const pageWidth = 680
      const layoutStyle = emailWindow.document.createElement('style')
      const pageStyle = emailWindow.document.createElement('style')

      layoutStyle.textContent = `
        html, body {
          width: ${pageWidth}px !important;
          max-width: none !important;
          margin: 0 auto !important;
          overflow: visible !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        body {
          box-sizing: border-box !important;
          padding: 20px !important;
        }

        @media print {
          html, body {
            margin: 0 !important;
          }
        }
      `

      const updatePrintPageSize = () => {
        const documentElement = emailWindow.document.documentElement
        const body = emailWindow.document.body
        const contentHeight = Math.max(
          documentElement.scrollHeight,
          body.scrollHeight,
          body.getBoundingClientRect().height
        )

        // Extra space prevents print rounding from pushing an indivisible footer to a new page.
        const pageHeight = Math.ceil(contentHeight) + 20

        pageStyle.textContent = `
          @page {
            size: ${pageWidth}px ${pageHeight}px;
            margin: 0;
          }
        `
      }

      emailWindow.document.head.appendChild(layoutStyle)
      emailWindow.document.head.appendChild(pageStyle)
      updatePrintPageSize()
      emailWindow.addEventListener('load', updatePrintPageSize)
      emailWindow.addEventListener('beforeprint', updatePrintPageSize)

      if (emailWindow.document.fonts) {
        emailWindow.document.fonts.ready.then(updatePrintPageSize)
      }
    }
  }
}
</script>
